import { useState,
  experimental_useEffectEvent as useEffectEvent,
  useEffect
 } from "react";
 import { loggedInSelector } from "#/features/auth/authSelectors";
import { useAppSelector } from "#/store";
import { Community } from "lemmy-js-client";
import { clientSelector } from "#/features/auth/authSelectors";

import GuestCommunitiesList from "./GuestCommunitiesList";
import LoggedInCommunitiesList from "./LoggedInCommunitiesList";

export interface CommunitiesListProps {
  actor: string;
  communities?: Community[] | undefined;
}

export default function CommunitiesList(props: CommunitiesListProps) {
  const loggedIn = useAppSelector(loggedInSelector);
  const [communities, setCommunities] = useState<Community[]>();
  const client = useAppSelector(clientSelector);

  async function update() {
    let communities;

    try {
      ({ communities } = await client.listCommunities({
        type_: "All",
        sort: "TopAll",
        limit: 50,
      }));
    } catch (error) {
      setCommunities([]);
      throw error;
    }

    setCommunities(communities.map((c) => c.community));
  }

  const updateEvent = useEffectEvent(update);

  useEffect(() => {
    setCommunities([]);

    updateEvent();
  }, [client, props.actor]);

  const List = loggedIn ? LoggedInCommunitiesList : GuestCommunitiesList;

  return <List {...props} communities={communities || []} />;
}
